<template>
  <div>
    <form class="grid grid-cols-4 gap-4" @submit.prevent="onSubmit">
      <InputText
        keyId="0"
        :placeholder="item.label"
        :label="
          item.type === 'radioGroup'
            ? 'Rubrik för radiogrupp'
            : 'Rubrik för checkboxgrupp'
        "
        :model="item.label"
        type="text"
        @change="onLabelChange"
        class="col-span-full"
      ></InputText>
      <div
        class="flex col-span-full gap-4 items-center"
        v-for="(prop, i) in item.data.keys"
        :key="i"
      >
        <BaseInput
          v-model="prop.label"
          :label="
            item.type === 'radioGroup'
              ? `radioknapp ${i + 1}`
              : `checkbox ${i + 1}`
          "
          placeholder="Ange texten för checkboxen"
        />
        <i
          @click="removeOption(prop)"
          title="Ta bort"
          class="fas fa-trash-alt text-red-2 hover:text-red-2 text-2xl cursor-pointer"
        ></i>
      </div>
    </form>
    <div class="flex gap-4 mt-4">
      <RegularButton @click="addOption" text="Lägg till val" />
      <RegularButton @click="remove" style-type="cancel" text="Ta bort grupp" />
    </div>
  </div>
</template>
<script setup lang="ts">
import { defineProps, ref } from "vue";
import { defineEmits, onMounted } from "@vue/runtime-core";
import InputCheckbox from "@/features/shared/components/form/InputCheckbox.vue";
import InputText from "@/features/shared/components/form/InputText.vue";
import * as dtos from "@/models/dtos";
import { useStore } from "vuex";
import InputCheckbox2 from "./InputCheckbox2.vue";
import InputText3 from "./InputText3.vue";
import { DynamicProperty } from "../../models/dtos";
import { FormBuilder2 } from "../../models/FormBuilder2";
import { ToastNotification } from "@/models/ToastNotification";
import InputText2 from "./InputText2.vue";
import BaseInput from "./BaseInput.vue";
import RegularButton from "../ui/RegularButton.vue";

let formIndex = 10000;
const emit = defineEmits(["change", "remove", "isEdit"]);
const store = useStore();
const form = ref(store.getters.form as FormBuilder2);
const props = defineProps<{
  model: dtos.DynamicProperty;
  index: number;
}>();
const old = JSON.parse(JSON.stringify(props.model));
const item = ref(props.model as DynamicProperty);

function remove() {
  store.dispatch(
    "addNotification",
    new ToastNotification("success", "Gruppen har tagits bort")
  );
  const form = store.getters.form as FormBuilder2;
  form.removeByProperty(item.value);
  emit("isEdit", false);
}
function removeOption(optionKey: DynamicProperty) {
  form.value.removeOptionFromGroup(item.value.data, optionKey, item.value.key);
}

function addOption() {
  form.value.addOptionToGroup(item.value.data, item.value.key);
}

function onLabelChange(event: any) {
  item.value.label = event;
  item.value.placeholder = event;
}
</script>
<style></style>
